import React, { useEffect } from "react";
import "./ConfirmModal.css";

const ConfirmModal = ({ isOpen, mode = "single", taskName, taskCount = 0, onConfirm, onCancel }) => {
  // Close on Escape key
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") onCancel();
      if (e.key === "Enter") onConfirm();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onCancel, onConfirm]);

  if (!isOpen) return null;

  const isRemoveAll = mode === "all";

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className={`modal-box ${isRemoveAll ? "modal-box--danger" : ""}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        {/* Warning icon */}
        <div className={`modal-icon ${isRemoveAll ? "modal-icon--all" : ""}`}>
          <i className={isRemoveAll ? "fas fa-radiation-alt" : "fas fa-exclamation-triangle"}></i>
        </div>

        <h2 className="modal-title" id="modal-title">
          {isRemoveAll ? "Remove All Tasks?" : "Delete Task?"}
        </h2>

        <p className="modal-body">
          {isRemoveAll ? (
            <>
              This will permanently delete{" "}
              <span className="modal-task-name">
                all {taskCount} task{taskCount !== 1 ? "s" : ""}
              </span>{" "}
              from your list.
              <br />
              <small>This action cannot be undone.</small>
            </>
          ) : (
            <>
              Are you sure you want to delete
              <br />
              <span className="modal-task-name">"{taskName}"</span>?
              <br />
              <small>This action cannot be undone.</small>
            </>
          )}
        </p>

        <div className="modal-actions">
          <button className="modal-btn modal-btn-cancel" onClick={onCancel}>
            <i className="fas fa-times"></i> Cancel
          </button>
          <button className="modal-btn modal-btn-delete" onClick={onConfirm}>
            <i className="fas fa-trash-alt"></i>{" "}
            {isRemoveAll ? "Remove All" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
